<template>
  <v-dialog
    :value="value"
    max-width="50rem"
    persistent
    @input="val => $emit('input', val)">
    <v-card>
      <v-card-text>
        <v-form v-model="valid">
          <v-container grid-list-sm>
            <v-layout>
              <v-flex>
                <v-text-field
                  v-model="editedItem.name"
                  :rules="[v => !!v || 'Name is required']"
                  label="Name"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="posting"
          flat
          @click="$emit('input', false)">
          Cancel
        </v-btn>
        <v-btn
          :disabled="posting || !valid"
          flat
          @click="edit">
          <v-progress-circular
            v-if="posting"/>
          <span v-else>Save</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "edit-dialog",
  props: {
    // Initial item will be copied when dialog opens up (see watch)
    item: {
      required: true,
      type: Object
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      // Buffered item while editing
      editedItem: { name: "" },
      posting: false,
      valid: false
    };
  },
  watch: {
    value (open) {
      if (open) {
        this.editedItem.name = this.item.name;
      }
    }
  },
  methods: {
    edit () {
      this.posting = true;
      this.$http.
        put(
          `/api/site_configuration_items/${this.item.id}`,
          { name: this.editedItem.name }
        ).
        then(() => {
          this.$emit("input", false);
          this.$emit("refresh");
        }).
        finally(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/SiteConfItems/EditDialog.vue